var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('div',{staticClass:"centered"},[_c('Breadcrumb',{attrs:{"crumbs":[
				{
					text : 'Home',
					to : {name:'templates'},
				},
				{
					text : 'Settings',
					to : {name:'settings'},
				} ]}}),_vm._v(" "),_c('UserPageNav'),_vm._v(" "),_c('h1',[_vm._v("Profile settings")]),_vm._v(" "),_c('div',{staticClass:"raised-box p-box"},[_c('SimpleForm',{attrs:{"onSubmit":_vm.onSubmit,"fields":[
						{
							label : 'First name',
							name : 'first_name',
							autofocus : true,
							required : true,
							// label_help : 'Accepts alphanumeric characters and underscores.',
						},
						{
							label : 'Last name',
							name : 'last_name',
							required : true,
						} ],"model":_vm.user}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }